// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"e754c6e7","41":"c6944452","547":"d3525266","647":"d3525266","656":"bfaed032","913":"d3525266","986":"ddf07d4e"}[chunkId] + ".chunk.css";
};